import { User } from "../../types/auth";
import { LogoResponse } from "../brands/types";
import { CompetitorWithLogo } from "../../types/competitor";
import { SubscriptionPlan } from "@/constants/plans";

export type AuthState = {
  user: User | null;
  role: Role;
  isRecovery: boolean;
  loading: boolean;
  loadingUpdate: boolean;
  isTrial: boolean;
  isMember: boolean;
  isAgency: boolean;
  isManagedClient: boolean;
  accountId: string | null;
  actingAsClientId: string | null;
  actingAsAccountId: string | null;
  actingAsLabel: string | null;
  actingAsEmail: string | null;
  paymentStatus: PaymentStatus;
  errorRegister: string | null;
  errorLogin: string | null;
  errorResetPassword: string | null;
  successResetPassword: boolean;
  subscriptionPlan?: string | null;
  accountRegister: AccountRegisterState;
};

export type AccountRegisterState = {
  step: number;

  loading: boolean;
  loadingBrandRegister: boolean;
  loadingCompetitors: boolean;
  loadingRelatedBrands: boolean;

  plan: SubscriptionPlan;
  company: Company | null;
  relatedBrands: LogoResponse[] | null;

  competitors: CompetitorWithLogo[] | null;
  selectedCompetitors: CompetitorWithLogo[] | null;
};

export type Company = {
  name: string;
  website?: string;
  logoUrl?: string;
  description?: string;
  region?: string;
  brandType?: string;
  industry?: string;
  primaryLanguage?: string;
  targetAudience?: string;
};

export type RelatedBrand = {
  logo_url?: string;
  name: string;
  domain?: string;
};

export type PaymentStatus = "unknown" | "pending" | "paid" | "not_paid";
export type OAuthType = "google" | "azure" | "apple";
export type Role = "superuser" | "user";

export type JWT = {
  user_role: Role;
  is_subscribed: UserStatus;
  selectedBrandId: number;
};

export type AuthError = {
  code: string;
  message: string;
};

export enum UserStatus {
  Subscribed = "Subscribed",
  RecentUnsubscribed = "RecentUnsubscribed",
  Inactive = "Inactive",
}

export type BrandRegisterResponse = {
  brand_suggestions: Array<BrandSuggestion>;
  confidence: string;
};

export type BrandSuggestion = {
  name: string;
  website: string | null;
  description: string;
  region?: string | null;
  brand_type?: string | null;
  industry?: string | null;
  primary_language?: string | null;
};

export type CompetitorsResponse = {
  competitors: Array<{
    name: string;
    url: string;
    description?: string;
  }>;
};

export type RegisterPayload = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
};

export type AuthorizationUserPayload = {
  user: User;
  isRegister: boolean;
  isSubscribed?: boolean;
  userRole?: Role;
  selectedBrandId?: number;
};

export type OAuthPayload = {
  type: OAuthType;
  isRegister: boolean;
};

export type LoginPayload = {
  email: string;
  password: string;
};

export type ForgotPasswordPayload = {
  email: string;
};

export type FetchPaymentStatusPayload = {
  email: string;
};

export type UpdateUserPayload = {
  firstName: string;
  lastName: string;
};

export type UpdatePasswordPayload = {
  oldPassword: string;
  password: string;
};

export type ResetPasswordPayload = {
  password: string;
};

export type FetchRelatedBrandsPayload = {
  brand: string;
};

export type RegisterOAuth = {
  company: Company | null;
  competitors: CompetitorWithLogo[] | null;
  selectedCompetitors: CompetitorWithLogo[] | null;
  plan: SubscriptionPlan;
};